import React from 'react';

const AffiliateDisclosure = () => {
  return (
    <div className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 py-3 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-center text-center">
          <p className="text-xs text-gray-600 dark:text-gray-400 leading-relaxed">
            ⚖️ <span className="font-medium">Amazon Associates Disclosure:</span>{' '}
            As an Amazon Associate, Lawn.Smart earns from qualifying purchases. 
            This means we may earn a commission when you click on or make purchases via our Amazon links, 
            at no additional cost to you.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AffiliateDisclosure;